window.ID_CORE = {
  Video: {
    globalConfig: {
      playerOptions:{
        audioVolume: 'horizontal',
        videoVolume: 'horizontal'
      },
      skin: {
        name:'inv-custom-player',
        iconPrimaryColor: 'darkred',
        iconSecondaryColor: 'white',
        icons:{
          play:'<span class="play-icon"></span>',
          pause:'<span class="pause-icon"></span>',
          loadingGif: '<img src="/sites/brookfield-intranet/themes/investis_project/images/video-loader.gif" />',
          overlayPlay: '',
          volume: '<span class="inv_soundOnOffBtn"></span>',
        }
      }
    }
  }
}
